import { Button, Modal } from "react-bootstrap"
import { LoadingIcon } from "../../Loading";

type DeleteModalProps = {
    show: boolean;
    docname: string;
    isLoading: boolean;
    setDeleteModal;
    handleDelete;
}

const DeleteModal = ({
    show,
    docname,
    isLoading,
    setDeleteModal,
    handleDelete,
}: DeleteModalProps) => {
    return (
        <Modal centered show={show}>
            <Modal.Header>
                <Modal.Title>Delete permanently?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading ?
                    <LoadingIcon showMsg={true} extraMsg={`Deleting document`} inline={true} />
                    :
                        <>
                            Are you sure you want to delete "{docname}"?
                        </>
                }
            </Modal.Body>
            <Modal.Footer>
                {!isLoading &&
                    <>
                        <Button variant="text" onClick={(e) => { setDeleteModal({ show: false, dname: null, docID: null }) }}>Cancel</Button>
                        <Button variant="primary" onClick={(e) => {handleDelete()}}>Delete</Button>
                    </>
                }
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteModal;